import React, { useContext } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import logo from '../../assets/oyecreators-logo.svg';
import { Link, useNavigate } from 'react-router-dom';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { WindowWidthContext } from '../context/user-details-context';
import { Drawer } from '@mui/material';
import { AppBarBoxStyle } from '../../mui/website-mui-style';

const navItems = ['Blogs', 'Pricing'];

const WebsiteNavbar = ({ handleDrawerToggle, mobileOpen, setMobileOpen }) => {
    const windowWidth = useContext(WindowWidthContext);
    const navigate = useNavigate();

    const darkTheme = createTheme({
        components: {
            MuiAppBar: {
                styleOverrides: {
                    root: {
                        backgroundColor: '#f4f0fa',
                        boxShadow: 'none',
                        position: 'relative',
                        height: '100px',
                        display: 'flex',
                        justifyContent: 'center',

                    },
                },
            },
        },
    });

    const getRoutePath = (item) => {
        switch (item) {
            case 'Blogs':
                return '/blog';
            case 'Pricing':
                return '/pricing-page';
            default:
                return '/';
        }
    };

    const drawerWidth = 240;

    const drawer = (
        <Box onClick={() => setMobileOpen(false)} sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div className='flex flex-col'>
                <div className='flex justify-center'>
                    <Typography variant="h6" sx={{ my: 3 }} className='w-32 flex align-center'>
                        <Link to="/" aria-current="page" aria-label="home">
                            <img className="max-xs:max-w-[100%] max-xs:h-auto" src={logo} alt="AAA logo" />
                        </Link>
                    </Typography>
                </div>
                <Divider />
                <div>
                    <List>
                        {navItems.map((item) => (
                            <ListItem key={item} disablePadding>
                                <ListItemButton onClick={() => {
                                    setMobileOpen(false);
                                    navigate(getRoutePath(item));
                                }}>
                                    <ListItemText primary={item} />
                                </ListItemButton>
                            </ListItem>

                        ))}
                    </List>
                </div>
            </div>
            <div className="flex flex-col gap-4 pr-8 pl-8 pb-24">
                <Link to="/signup/for-businesses" className="border border-solid border-primary-500 text-primary-500 rounded-full text-14 flex justify-center no-underline font-sans items-center pt-2 pb-2 xl:font-bold font-semibold">For Business</Link>
                <a href="https://app.oyecreators.com/" rel="noopener noreferrer" className="bg-primary-500 rounded-full text-14 flex justify-center no-underline font-sans text-white items-center pt-2 pb-2 xl:font-bold font-semibold">For Creators</a>
            </div>
        </Box>
    );

    return (
        <ThemeProvider theme={darkTheme} >
            <>
                <AppBar component="nav" sx={{
                    '@media (min-width: 1728px)': {
                        height: '144px',
                    },
                }} >
                    <Box sx={AppBarBoxStyle}>
                        <Toolbar className='flex justify-between' >
                            <Typography>
                                <Link to="/" aria-current="page" aria-label="home">
                                    <img className="w-40 xl:w-60 h-24 xl:h-[140px] max-xs:w-28" src={logo} alt="AAA logo" />
                                </Link>
                            </Typography>
                            <IconButton
                                color="inherit"
                                aria-label="open drawer"
                                edge="start"
                                onClick={handleDrawerToggle}
                                sx={{ m: 0, p: 0, display: windowWidth <= 799 ? 'block' : 'none' }}
                                className="hidden max-xs:block max-md:block"
                            >
                                <MenuIcon sx={{ color: 'black', m: 0 }} />
                            </IconButton>
                            <div
                                style={{ display: windowWidth <= 799 ? 'none' : 'flex', alignItems: 'center' }}
                                className="gap-7 xl:gap-14 ">
                                {navItems.map((item) => (
                                    <div
                                        key={item}
                                        onClick={() => navigate(getRoutePath(item))}
                                        className="text-secondary-200 capitalize mx-2 sm:mx-1 text-16 xl:text-20 font-semibold cursor-pointer font-sans"
                                    >
                                        {item}
                                    </div>
                                ))}
                            </div>
                            <Box
                                className='max-xs: hidden   '
                                sx={{ display: windowWidth <= 799 ? 'none' : 'flex', alignItems: 'center', justifyContent: 'flex-end' }}
                            >
                                <div className="flex gap-7 xl:gap-12">
                                    <Link to="/signup/for-businesses" className="border border-solid border-primary-500 text-primary-500 rounded-full text-14 no-underline font-sans flex items-center justify-center pt-2 pr-6 pb-2 pl-6 xl:font-bold font-semibold">For Business</Link>
                                    <a href="https://app.oyecreators.com/" rel="noopener noreferrer" className="bg-primary-500  rounded-full	text-14 text-white no-underline font-sans  flex items-center justify-center pt-2 pr-6 pb-2 pl-6  xl:font-bold font-semibold">For Creators</a>
                                </div>
                            </Box>
                        </Toolbar>
                    </Box>
                </AppBar>
            </>
            <Drawer
                anchor="right"
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true,

                }}
                className="hidden max-xs:block"
                PaperProps={{
                    className: `box-sizing-border w-[${drawerWidth}px]`,
                }}
                sx={{
                    display:
                        windowWidth <= 799 ? 'block' :
                            'none',
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, height: 'auto' },
                }}
            >
                {drawer}
            </Drawer>
        </ThemeProvider>
    );
};

export default WebsiteNavbar;
